module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"Hourly Trends":"時間帯別混雑状況","Daily Trends":"日別混雑状況","AverageOccupancy":"平均混雑％","Staff":"スタッフ人数","Occupancy":"店内滞在人数","In":"来店客数","Out":"退店客数"}}')
  delete Component.options._Ctor
}
